import * as React from "react";
import { withFormik, FormikProps, Field, Form as FForm } from "formik";
import { Form, Icon, Button } from "antd";
import { Link } from 'react-router-dom';
import { loginValidationSchema, ROUTE_NAMES } from '@bakbak/common';
import { LoginMutation_login, LoginMutationVariables, LoginMutation_login_user } from "@bakbak/controller";
import { InputField } from "../../../util/InputField";
import { THEME_COLOR } from "../../../constants";

const FormItem = Form.Item;

interface FormValues {
	email: string;
	password: string;
}
interface Props {
	onComplete: (user: LoginMutation_login_user | null) => void;
	onCancel: () => void;
	submit: (values: LoginMutationVariables) => Promise<LoginMutation_login | null>
}

class LoginForm extends React.PureComponent<
	FormikProps<FormValues> & Props
	> {
	render() {
		return (
			<FForm style={{ display: "flex", marginTop: 20 }}>
				<div style={{ width: 400, margin: "auto" }}>
					<div style={{ fontSize: 32, fontWeight: 600, marginBottom: 20, color: THEME_COLOR }}>Login</div>
					<Field
						name="email"
						prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} /> as any}
						placeholder="email"
						component={InputField}
					/>
					<Field
						name="password"
						prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} /> as any}
						placeholder="password"
						type="password"
						component={InputField}
					/>

					<FormItem>
						<Link to={ROUTE_NAMES.FORGOT_PASSWORD}>Forgot password</Link>
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
							<Button htmlType="submit" style={{
								width: '40%', backgroundColor: THEME_COLOR, color: 'white', borderColor: THEME_COLOR
							}}>
								Login
							</Button>
							<Button onClick={this.props.onCancel} style={{
								width: '40%', backgroundColor: 'Grey', color: 'white', borderColor: 'grey'
							}}>
								Cancel
							</Button>
						</div>

						Or <Link to={ROUTE_NAMES.REGISTER}>Register now!</Link>
					</FormItem>
				</div>
			</FForm>
		);
	}
}

export const LoginView = withFormik<Props, FormValues>({
	validationSchema: loginValidationSchema,
	mapPropsToValues: () => ({ email: "", password: "" }),
	handleSubmit: async (values, { props, setErrors }) => {
		const response = await props.submit(values);
		if (response && response.errors) {
			setErrors(response.errors as any);
		} else if (response) {
			props.onComplete(response.user);
		}
	}
})(LoginForm);



// WEBPACK FOOTER //
// ./src/modules/auth/login/LoginView.tsx